import { render, staticRenderFns } from "./RentObjectLocation.vue?vue&type=template&id=71ec5704&scoped=true&lang=pug"
import script from "./RentObjectLocation.vue?vue&type=script&lang=js"
export * from "./RentObjectLocation.vue?vue&type=script&lang=js"
import style0 from "./RentObjectLocation.vue?vue&type=style&index=0&id=71ec5704&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71ec5704",
  null
  
)

export default component.exports